import { useAtom, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { Modal } from "@/components/Interface/Modal/Modal";
import { useIsMobile } from "@/hooks/useIsMobile";
import {
  clearAuthAtom,
  isAnonymousUserAtom,
  showsSessionExpiredModalAtom,
  verifierAtom,
} from "@/utils/atoms";
import { generateVerifier } from "@/utils/authentication";

export const SessionExpiredModal = () => {
  const isMobile = useIsMobile();
  const [show, setShow] = useAtom(showsSessionExpiredModalAtom);
  const setShowSessionExpiredModal = useSetAtom(showsSessionExpiredModalAtom);
  const [, setVerifier] = useAtom(verifierAtom);
  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);
  const clearAuth = useSetAtom(clearAuthAtom);
  const { t } = useTranslation();

  const handleLoginRedirect = async () => {
    try {
      setShow(false);
      setShowSessionExpiredModal(undefined);

      // Clear auth tokens from localStorage (via atomWithStorage) so that
      // usePartnerLoginRedirect does not auto-redirect back to the cockpit
      // with stale credentials after the page reloads.
      clearAuth();

      // Generate new verifier for the login flow
      const newVerifier = generateVerifier();
      setVerifier(newVerifier);

      const isPartnerRoute =
        window.location.hash.startsWith("#/partner") ||
        window.location.hash.startsWith("#/welcome-partner");
      window.location.assign(
        isPartnerRoute ? "/#/welcome-partner" : "/#/welcome",
      );
    } catch (error) {
      console.error(error);
    }
  };

  // Don't show the modal for anonymous users
  if (!show || isAnonymousUser) {
    return null;
  }

  return (
    <Modal
      title={t("sessionExpired.title")}
      onClose={() => {}}
      showCloseButton={false}
      hasScroll={false}
      variant="dark"
    >
      <div>
        <p className="mb-4">{t("sessionExpired.text")}</p>
        <div className="flex justify-end">
          <Button
            variant="primary"
            inverted
            fullWidth={isMobile}
            onClick={handleLoginRedirect}
          >
            {t("sessionExpired.backToHome")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
